import { Helmet } from 'react-helmet-async';
import { Box,Button,Grid,Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {  getDeviceInfos } from'../../api'
import { useForm } from 'react-hook-form';
import FormProvider, { RHFSelect, RHFTextField } from '../../components/hook-form';
import dayjs from 'dayjs';
import TableNoData from 'src/components/table/TableNoData';
const DEFAULT_ROWS_PER_PAGE = 10;
export default function DeviceManageList() {
  const [page, setPage] = React.useState(0);
  const [rowsLength,setRowsLength] = useState(0)
  const [rows,setRows] = useState<any>([])
  const [rowsPerPage, setRowsPerPage] = React.useState(DEFAULT_ROWS_PER_PAGE);
  const defaultValues = {
    model_key: '',
    status: '',
  }
  const methods = useForm({
    defaultValues,
  });
  const {
    reset,
    handleSubmit,
    getValues,
  } = methods;
  
  const formatCreatedTime = (value: any) => {
    if (!value) {
      return '-'
    }
    const numericValue = Number(value)
    const parsed = Number.isFinite(numericValue) && `${value}`.length === 10 ? numericValue * 1000 : value
    return dayjs(parsed).format('YYYY-MM-DD HH:mm')
  }

  const normalizeDevices = React.useCallback((list: any[] = []) =>
    list.map((item) => {
      return {
        id: item?.id ?? '',
        serialNumber: item?.serial_number ?? '-',
        name: item?.name ?? '-',
        deviceModelCode: item?.device_model_code ?? '-',
        status: item?.status ?? '-',
        isEnabled: item?.is_enabled ?? false,
        firmwareVersion: item?.firmware_version ?? '-',
        ipAddress: item?.ip_address ?? '-',
        macAddress: item?.mac_address ?? '-',
        lastSeenAt: item?.last_seen_at ?? 0,
        location: item?.location ?? '-',
        createdAt: item?.created_at ?? 0,
        updatedAt: item?.updated_at ?? 0,
        userId: item?.user_id ?? '',
        raw: item,
      }
    }), [])

  const handleSearchQuestion = React.useCallback(async()=> {
    try {
      const formValues = getValues()
      const filters: Record<string, any> = {}
      
      if (formValues?.model_key?.trim()) {
        filters.model_key = formValues.model_key.trim()
      }
      if (formValues?.status) {
        filters.status = formValues.status
      }
      
      const query = {
        page: page + 1,
        page_size: rowsPerPage,
        ...filters,
      }
      console.log('设备列表请求参数:', JSON.stringify(query, null, 2))
      const res:any = await getDeviceInfos(query)
      console.log('设备列表响应:', JSON.stringify(res, null, 2))
      if(res?.code===200) {
        const list = Array.isArray(res?.data?.items) ? res.data.items : []
        const normalized = normalizeDevices(list)
        const total = typeof res?.data?.total === 'number' ? res.data.total : normalized.length
        setRows(normalized)
        setRowsLength(total)
      } else {
        setRows([])
        setRowsLength(0)
      }
    } catch (error) {
      console.error('获取设备列表失败:', error)
      setRows([])
      setRowsLength(0)
    }
  }, [page, rowsPerPage, getValues, normalizeDevices])
  
  useEffect(()=>{
    handleSearchQuestion()
  },[handleSearchQuestion])
  const handleChangePage = React.useCallback(
    (event: unknown, newPage: number) => {
      setPage(newPage);
    },
    [],
  );
  const handleChangeRowsPerPage = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const updatedRowsPerPage = parseInt(event.target.value, 10);
      setRowsPerPage(updatedRowsPerPage);
      setPage(0);
    },[],
  );
  const onSubmit = async () => {
    if (page !== 0) {
      setPage(0);
    } else {
      await handleSearchQuestion();
    }
  };
    return(
        <>
        <Helmet>
          <title>设备列表</title>
        </Helmet>    

        <Typography variant="h4" component="h2">
          设备列表
        </Typography>

        <Box sx={{ width: '100%' }}>
          <Paper sx={{ width: '100%', mb: 2,mt:6 }}>
          <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={9}>
              <Box
                  sx={{
                    '& > :not(style)': { m: 1, width: '25ch' },
                  }}
                >
                   <RHFTextField name="model_key"  label="设备型号" />
                  <RHFSelect native name="status" label="状态" placeholder="设备状态">
                    <option value='' />
                    {[
                      {key:'在线',value:'online'},
                      {key:'离线',value:'offline'},
                      {key:'配置中',value:'provisioning'},
                      {key:'故障',value:'fault'}
                    ].map((val) => (
                      <option key={val.value} value={val.value}>
                        {val.key}
                      </option>
                    ))}
                  </RHFSelect>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Button variant="contained" sx={{m:'10px'}}  type="submit">搜索</Button>
                <Button
                  variant="outlined"
                  sx={{m:'10px'}}
                  onClick={async () => {
                    reset();
                    if (page !== 0) {
                      setPage(0);
                    } else {
                      await handleSearchQuestion();
                    }
                  }}
                >重置</Button>
              </Grid>
            </Grid>
            </FormProvider>
            <Stack
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={2}
              mr={3}
            >
               {/* <Button variant="contained" component={RouterLink} sx={{m:'10px'}} to={PATH_DASHBOARD.userManage.add}>新增用户</Button> */}
            </Stack>
            <TableContainer component={Paper}>
            <Table sx={{ minWidth: 1200 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>序列号</TableCell>
                  <TableCell align="center">设备名称</TableCell>
                  <TableCell align="center">设备型号</TableCell>
                  <TableCell align="center">状态</TableCell>
                  <TableCell align="center">是否启用</TableCell>
                  <TableCell align="center">固件版本</TableCell>
                  <TableCell align="center">IP地址</TableCell>
                  <TableCell align="center">最后在线</TableCell>
                  <TableCell align="center">创建时间</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row:any) => (
                  <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.serialNumber}
                    </TableCell>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{row.deviceModelCode}</TableCell>
                    <TableCell align="center">
                      <Chip
                        label={
                          row.status === 'online' ? '在线' :
                          row.status === 'offline' ? '离线' :
                          row.status === 'provisioning' ? '配置中' :
                          row.status === 'fault' ? '故障' : row.status
                        }
                        color={
                          row.status === 'online' ? 'success' :
                          row.status === 'fault' ? 'error' :
                          row.status === 'provisioning' ? 'warning' : 'default'
                        }
                        size="small"
                        sx={{
                          minWidth: 70,
                          '&.MuiChip-root': {
                            borderRadius: '6px',
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell align="center">{row.isEnabled ? '是' : '否'}</TableCell>
                    <TableCell align="center">{row.firmwareVersion}</TableCell>
                    <TableCell align="center">{row.ipAddress}</TableCell>
                    <TableCell align="center">{formatCreatedTime(row.lastSeenAt)}</TableCell>
                    <TableCell align="center">{formatCreatedTime(row.createdAt)}</TableCell>
                  </TableRow>
                ))}
                  <TableNoData isNotFound={rows.length===0}/>
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={rowsLength}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </TableContainer>
          </Paper>
        </Box>
      </>
    )
}